<template>
    <div>
        <div class="flex justify-content-end">
            <q-btn v-if="! field.id" label="Save" color="primary" @click="create" :loading="loading" />

            <q-btn-dropdown
                v-if="field.id"
                dense
                split
                color="primary"
                :loading="loading"
                label="Save"
                @click="save"
            >
                <q-list>
                    <q-item clickable v-close-popup color="negative" @click="remove">
                        <q-item-section>
                            <q-item-label>Delete</q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-btn-dropdown>
        </div>

        <div class="mb-3">
            <label for="field_type">Type</label>
            <div v-if="hasValidationErrors('type')" class="text-negative text-caption text-weight-medium">
                {{ getValidationErrors('type') }}
            </div>

            <div v-if="field.id">
                <q-radio class="disabled" v-model="field.type" :val="field.type" :label="humanReadableType(field.type)" />
            </div>

            <div v-if="! field.id" class="d-flex column">
                <q-radio v-model="field.type" val="boolean" label="Boolean (logical)" />
                <q-radio v-model="field.type" val="multiple_select" label="Multiple select (checkboxes)" />
            </div>

        </div>
        <div class="mb-3">
            <label>Config</label>
            <div>
                <q-toggle
                    label="Allow filter"
                    v-model="field.show_filter"
                />
            </div>
            <div>
                <q-toggle
                    label="Show in columns by default"
                    v-model="field.show_list_default"
                />
            </div>
        </div>
        <div class="mb-3">
            <q-input
                label="Label"
                :error="hasValidationErrors('label')"
                 :error-message="getValidationErrors('label')"
                 @blur="clearValidationErrors"
                 v-model="field.label" />
        </div>
<!--        <div class="mb-2">
            <label for="field_name">Name</label>
            <input class="form-control" id="field_name" type="text" v-model="field.name">
        </div>-->
        <div class="mb-3" v-if="field.type === 'multiple_select'">
            <div class="d-flex justify-between mb-2">
                <label for="field_options" class="mr-2">Options</label>
                <q-btn dense label="Add" @click="addOption" />
            </div>
            <div v-if="hasValidationErrors('options')" class="text-negative text-caption text-weight-medium">
                {{ getValidationErrors('options') }}
            </div>

            <q-list bordered padding>
                <q-item :key="`${field.name}_${index}`" v-for="(option, index) in field.options">
                    <q-item-section avatar>
                        {{ option?.key || '' }}:
                    </q-item-section>

                    <q-item-section>
                        <q-item-label><q-input dense v-model="field.options[index].value" /></q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                        <q-btn dense flat label="delete" @click="deleteOption(index)" />
                    </q-item-section>
                </q-item>
            </q-list>
        </div>
    </div>
</template>

<script setup>
import {ref, defineProps, watch, defineEmits, toRaw} from "vue";
import { useQuasar } from 'quasar'
const $q = useQuasar()

import validationHelper from './../composables/useValidationHelper'

const { hasValidationErrors, getValidationErrors, setValidationErrors, clearValidationErrors } = validationHelper()

const emit = defineEmits(['create', 'save', 'remove']);

const defaultField = {
    name: '',
    label: '',
    type: 'boolean',
    required: false,
    show_list_default: false,
    show_filter: false,
    options: []
};

const field = ref({
    ...defaultField
})

const options = ref([])

const props = defineProps(['entry'])
watch(() => props.entry, (newValue) => {

    if (newValue.id) {
        field.value = {...toRaw(newValue)};
    }
    /*if (newValue.name) {
        props.entry.value[newValue.name] = newValue;
    }*/
}, {immediate: true})

const addOption = () => {

    if(! field.value.options) {
        field.value.options = [];
    }
    const nextKey = field.value.options.reduce((max, opt) => {
        return (Number(opt.key) > max) ? Number(opt.key) : max;
    }, 0) + 1

    field.value.options.push({
        key: nextKey,
        value: ''
    })
}
const deleteOption = (key) => {
    //field.value.options.splice(key, 1)
    field.value.options.splice(key, 1)
}

const processAsyncError = (error) => {
    switch (error.response.status) {
        case 500:
            $q.notify({
                type: 'negative',
                message: 'Server error'
            })
            break;
        case 403:
        case 429:
            $q.notify({
                type: 'negative',
                message: error.response.data
            })
            break;
        case 422:
            setValidationErrors(error.response.data)
            break;
    }
}

const create = () => {
    loading.value = true;

    window['APIv2'].requestWithAxios('virtual-fields', {
        field: field.value,
        workspace_id: window['APIv2'].workspace.id,
    }, 'POST').then((response) => {

        field.value = {...defaultField};
        emit('create', response.data);

    }).catch(processAsyncError).finally(() => {
        loading.value = false;
    })

}

const save = () => {
    loading.value = true;
    window['APIv2'].requestWithAxios(`virtual-fields/${field.value.id}`, {
        field: field.value,
        workspace_id: window['APIv2'].workspace.id,
    }, 'POST').then((response) => {
        emit('save', response.data);
    }).catch(processAsyncError)
        .finally(() => {loading.value = false;});
}

const remove = () => {
    loading.value = true;

    window['APIv2']._request(`virtual-fields/${field.value.id}`, {}, 'DELETE')
    .then((response) => {
        emit('remove', field.value.id);

        field.value = {...defaultField};

    }).catch((err) => {console.log(err)})
        .finally(() => {loading.value = false;});

}

const loading = ref(false);
/*
watch(this.entry, (newVal, oldVal) => {
            if (newVal.id) {
                this.field = {...newVal};
            }
        }, {immediate: true});
 */

const humanReadableType = (type) => {
    switch (type) {
        case 'boolean':
            return 'Boolean (logical)';
        case 'multiple_select':
            return 'Multiple select (checkboxes)';
        default:
            return 'Unknown';
    }
}

</script>

<style scoped>

</style>
